 // remove user submitted -(minus) from Search
 
 // Find the search form and add a submit event listener
  document.addEventListener('DOMContentLoaded', (event) => {
    const searchForm = document.querySelector('form[action="{{ routes.search_url }}"]'); // Adjust selector if needed
    const searchInput = document.querySelector('input[name="q"]'); // The search input field

    if (searchForm && searchInput) {
      searchForm.addEventListener('submit', function(e) {
        // Get the current value and remove all minus signs
        let query = searchInput.value;
        query = query.replace(/-/g, ''); // Replaces all occurrences of '-' with an empty string
        searchInput.value = query; // Update the input field value

        // If the query becomes empty after removal, you might want to prevent submission
        if (query.trim() === '') {
          e.preventDefault();
        }
      });
    }
  });